/* ==========================================================================
   LIMETRE - "De / Por" e economia total no carrinho
   --------------------------------------------------------------------------
   POR QUE ESSE ARQUIVO EXISTE

   Na pagina de produto a peca aparece como "de R$ 209,90 por R$ 164,90,
   economize R$ 45,00". Isso vem do PRECO COMPARATIVO (compare_at_price) da
   variante - nao e um desconto do Shopify, e so um preco de referencia.

   O tema Dawn so mostra preco riscado no carrinho quando existe um DESCONTO
   DE VERDADE na linha (item.original_line_price != item.final_line_price).
   E por isso que os brindes aparecem riscados e as pecas em promocao nao:
   os brindes tem desconto real, a peca tem preco comparativo.

   Este script preenche essa lacuna: le o compare_at_price de cada item do
   carrinho e mostra o "de" riscado + o total economizado, igual na PDP.

   IMPORTANTE: isso e APENAS EXIBICAO. Nao altera preco, nao cria desconto,
   nao mexe no valor cobrado. O checkout do Shopify continua sem o riscado -
   nao da pra mudar o checkout por codigo de tema, so com app/Checkout UI
   extension ou transformando a promocao em desconto automatico de verdade.

   ONDE E CARREGADO: snippets/meta-tags.liquid (junto com limetre-custom.js).
   ========================================================================== */
(function () {
  'use strict';

  var CLASSE = 'ltr-econ';           // marca tudo que este script injeta
  var PREFIXO_CACHE = 'ltrProd:';    // cache por produto no sessionStorage

  /* ---------------------------------------------------------------- estilo */
  function injetarEstilo() {
    if (document.getElementById('ltr-econ-css')) return;
    var s = document.createElement('style');
    s.id = 'ltr-econ-css';
    s.textContent = [
      '.ltr-econ-de{display:inline-block;margin-right:6px;color:#9a9a9a;',
      'text-decoration:line-through;font-weight:400;white-space:nowrap}',
      '.cart-item__price-wrapper .ltr-econ-de{display:block;margin:0 0 2px;',
      'font-size:1.2rem;line-height:1.2}',
      /* Colado no total: o valor economizado cai logo em cima do valor total.
         O justify-content real e copiado do bloco de totais em tempo de
         execucao (ver pintarTotais), porque desktop e mobile alinham
         diferente. Aqui fica so o fallback. */
      '.ltr-econ-total{display:flex;align-items:baseline;justify-content:flex-end;',
      'gap:8px;margin:0 0 2px;font-size:1.25rem;line-height:1.3;color:#0a7c3f;',
      'font-weight:600;letter-spacing:.02em}',
      '.ltr-econ-total__valor{white-space:nowrap}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ------------------------------------------------------------- dinheiro */
  var formatador = null;
  try {
    formatador = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  } catch (e) {}

  function brl(centavos) {
    var v = centavos / 100;
    if (formatador) return formatador.format(v);
    return 'R$ ' + v.toFixed(2).replace('.', ',');
  }

  /* --------------------------------------------------- dados dos produtos */
  var emMemoria = {};
  var emVoo = {};

  function lerCache(handle) {
    if (emMemoria[handle]) return emMemoria[handle];
    try {
      var bruto = sessionStorage.getItem(PREFIXO_CACHE + handle);
      if (bruto) {
        emMemoria[handle] = JSON.parse(bruto);
        return emMemoria[handle];
      }
    } catch (e) {}
    return null;
  }

  function gravarCache(handle, mapa) {
    emMemoria[handle] = mapa;
    try {
      sessionStorage.setItem(PREFIXO_CACHE + handle, JSON.stringify(mapa));
    } catch (e) {}
  }

  /* Busca /products/<handle>.js e devolve { variantId: {preco, de} } em centavos */
  function buscarProduto(handle) {
    var cache = lerCache(handle);
    if (cache) return Promise.resolve(cache);
    if (emVoo[handle]) return emVoo[handle];

    emVoo[handle] = fetch('/products/' + handle + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var mapa = {};
        if (p && p.variants) {
          p.variants.forEach(function (v) {
            mapa[String(v.id)] = {
              preco: v.price,
              de: v.compare_at_price || 0
            };
          });
        }
        gravarCache(handle, mapa);
        delete emVoo[handle];
        return mapa;
      })
      .catch(function () {
        delete emVoo[handle];
        return {};
      });

    return emVoo[handle];
  }

  /* ------------------------------------------------------------- leitura */
  function limpar(raiz) {
    (raiz || document).querySelectorAll('.' + CLASSE).forEach(function (el) {
      el.remove();
    });
  }

  /* Cada linha do carrinho, tanto na gaveta quanto na pagina /cart */
  function lerLinhas() {
    var linhas = [];
    document.querySelectorAll('.cart-item').forEach(function (item) {
      var input = item.querySelector('input.quantity__input[data-quantity-variant-id]') ||
                  item.querySelector('input.quantity__input');
      var link = item.querySelector('a.cart-item__name') || item.querySelector('a[href*="/products/"]');
      var caixaPreco = item.querySelector('.cart-item__price-wrapper');
      if (!input || !link || !caixaPreco) return;

      /* Linha que JA tem desconto real do Shopify (brinde, cupom): o proprio
         tema mostra o riscado. Nao mexer, pra nao ter dois riscados. */
      if (caixaPreco.querySelector('.cart-item__discounted-prices')) return;

      var variante = input.getAttribute('data-quantity-variant-id') ||
                     (link.href.match(/[?&]variant=(\d+)/) || [])[1];
      var handle = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      var qtd = parseInt(input.value, 10);
      if (!variante || !handle || !qtd || qtd < 1) return;

      linhas.push({
        variante: String(variante),
        handle: handle[1],
        qtd: qtd,
        caixaPreco: caixaPreco
      });
    });
    return linhas;
  }

  /* ------------------------------------------------------------ pintura */
  function pintarLinha(linha, info) {
    if (!info || !info.de || info.de <= info.preco) return 0;

    var deLinha = info.de * linha.qtd;
    var economia = (info.de - info.preco) * linha.qtd;

    var atual = linha.caixaPreco.querySelector('.price');
    if (!atual) return economia;

    var s = document.createElement('s');
    s.className = CLASSE + ' ltr-econ-de';
    s.textContent = brl(deLinha);
    atual.parentNode.insertBefore(s, atual);

    return economia;
  }

  function pintarTotais(economia) {
    if (economia <= 0) return;

    document.querySelectorAll('.totals').forEach(function (totais) {
      if (!totais.querySelector('.totals__total-value, .totals__subtotal-value')) return;
      if (!totais.parentNode) return;

      var linha = document.createElement('div');
      linha.className = CLASSE + ' ltr-econ-total';
      linha.innerHTML =
        '<span>VOCÊ ECONOMIZOU</span>' +
        '<span class="ltr-econ-total__valor">' + brl(economia) + '</span>';

      /* Copia o alinhamento do proprio bloco de totais em vez de chutar um.
         No desktop o total fica na direita e no mobile fica centralizado - com
         flex-end fixo, no celular a linha ia pro canto e desgrudava do preco.
         Valores "space-*" viram flex-end, porque dinheiro mora na direita. */
      try {
        var jc = getComputedStyle(totais).justifyContent;
        if (!jc || jc === 'normal' || jc === 'flex-start' || jc === 'start' ||
            jc === 'left' || jc.indexOf('space-') === 0) {
          jc = 'flex-end';
        }
        linha.style.justifyContent = jc;
      } catch (e) {}

      totais.parentNode.insertBefore(linha, totais);
    });
  }

  /* -------------------------------------------------------------- ciclo */
  var rodando = false;
  var pendente = null;

  function atualizar() {
    /* se ja tem uma rodada em andamento, reagenda em vez de perder o gatilho */
    if (rodando) { agendar(300); return; }

    var linhas = lerLinhas();

    limpar();
    if (!linhas.length) return;

    rodando = true;

    var handles = [];
    linhas.forEach(function (l) {
      if (handles.indexOf(l.handle) === -1) handles.push(l.handle);
    });

    Promise.all(handles.map(buscarProduto))
      .then(function (resultados) {
        var porHandle = {};
        handles.forEach(function (h, i) { porHandle[h] = resultados[i] || {}; });

        /* limpa de novo: o carrinho pode ter sido re-renderizado durante o fetch */
        limpar();

        var economia = 0;
        lerLinhas().forEach(function (l) {
          var mapa = porHandle[l.handle];
          if (!mapa) return;
          economia += pintarLinha(l, mapa[l.variante]);
        });

        pintarTotais(economia);
      })
      .catch(function () {})
      .then(function () { rodando = false; });
  }

  function agendar(ms) {
    clearTimeout(pendente);
    pendente = setTimeout(atualizar, ms || 150);
  }

  function iniciar() {
    injetarEstilo();
    atualizar();

    /* o tema re-renderiza as secoes do carrinho a cada mudanca de quantidade */
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { agendar(250); }); } catch (e) {}
    }

    /* a loja esta configurada como cart_type "notification", entao na pratica
       o que existe e a pagina /cart - mas deixo a gaveta na lista pra nao
       quebrar se um dia o ajuste mudar */
    var alvos = [
      document.getElementById('CartDrawer-CartItems'),
      document.getElementById('main-cart-items'),
      document.getElementById('main-cart-footer'),
      document.querySelector('cart-drawer'),
      document.querySelector('cart-items'),
      document.querySelector('.cart__footer')
    ].filter(Boolean);

    /* girar o celular muda o alinhamento do bloco de totais */
    window.addEventListener('resize', function () { agendar(350); });

    if (window.MutationObserver && alvos.length) {
      var vigia = new MutationObserver(function (mutacoes) {
        /* ignora as proprias injecoes, senao vira laco infinito */
        for (var i = 0; i < mutacoes.length; i++) {
          var m = mutacoes[i];
          var nosso = true;
          [].concat(
            Array.prototype.slice.call(m.addedNodes),
            Array.prototype.slice.call(m.removedNodes)
          ).forEach(function (n) {
            if (n.nodeType !== 1 || !n.classList.contains(CLASSE)) nosso = false;
          });
          if (!nosso) { agendar(200); return; }
        }
      });
      alvos.forEach(function (a) {
        vigia.observe(a, { childList: true, subtree: true });
      });
    }

    /* rede de seguranca: apps e o tema mexem no carrinho depois do load */
    [700, 2000].forEach(function (ms) { setTimeout(atualizar, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
